import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoCadastro } from 'src/app/modules/projeto-completo/models/projeto-cadastro.model';
import { ProjetoList } from 'src/app/modules/projeto-completo/models/projeto-list.model';
import { ProjetoPermission } from 'src/app/modules/projeto-completo/models/projeto-permission.model';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProjetoAgregadorService } from 'src/app/modules/projeto-completo/services/projeto-agregador.service';
import { AtributosProjeto } from 'src/app/shared/models/atributos-projeto.model';
import { Orgao } from 'src/app/shared/models/orgao.model';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { MaskService } from 'src/app/shared/services/mask.service';
import { OrgaoService } from 'src/app/shared/services/orgao.service';
import { StorageService } from 'src/app/shared/services/storage.service';

@Component({
  selector: 'app-agregador-cadastro-add',
  templateUrl: './agregador-cadastro-add.component.html',
  styleUrls: ['./agregador-cadastro-add.component.scss']
})

export class AgregadorCadastroAddComponent extends BaseFormComponent<ProjetoList> implements OnInit{

  idProjeto: number;
  idOrgaoUsuario: number;
  projeto: any;
  orgaoList: Orgao[];
  usuarioList: Usuario[];
  values_actived: any;
  attrList: AtributosProjeto;
  permissions: ProjetoPermission

  constructor(
    private myService: ProjetoAgregadorService,
    private router: Router,
    private storage: StorageService,
    private toastr: ToastrService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public maskService: MaskService,
    public orgaoService: OrgaoService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit() {
    this.initForm();
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.usuarioList = this.activatedRoute.snapshot.data["listUsuario"];
    this.attrList = this.activatedRoute.snapshot.data["listAtributosProjeto"];
    this.values_actived = this.attrList.actived;
    this.loaded()
  }

  initForm() {
    this.idOrgaoUsuario = this.storage.getInfoUser()?.orgao_id;

    this.form = this.fb.group({
      title:['',  [Validators.required]],
      description:[''],
      agency_id: [this.idOrgaoUsuario, [Validators.required]],
      manager_cpf: [null],
      actived:['1'], //default 1 conforme legado
      pg_id: [null],
      manager_adjunct: new FormArray([]),
    });
  }

  removeAdjunctManager(index: number) {
    this.getFormArray().removeAt(index);
  }

  addNewAdjunctManager() {
    this.getFormArray().push(new FormControl(null));
  }

  getFormArray(): FormArray {
    return this.form.get('manager_adjunct') as FormArray;
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro;
    data = Object.assign({}, data, this.form.value);
    if( this.idProjeto != undefined ) data.id = this.idProjeto;
    return data;
  }

  salvar() {
    if (this.form.valid) {
      this.addSub(
        this.myService.create(this.getDataCreate()).subscribe({
          next: (res: ProjetoCadastro) => {
            this.idProjeto = res.pf_id;
            this.confirmation('Cadastro criado com sucesso!').subscribe(() => {
              this.navigation.replace(['projetos', 'agregador', this.idProjeto, 'cadastro', 'editar']);
            });
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  voltar() {
    this.navigation.back(['projetos', 'agregador']);
  }
}
